export const EXISTING_PANEL = 'EXISTING';
export const ADD_NEW_PANEL = 'ADD_NEW';